import MainContent from '@/layouts/MainContent';
import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import PasswordConfiguration from './items/PasswordConfiguration';
import TowfactorAuthConfiguration from './items/TowfactorAuthConfiguration';
import { Helmet } from 'react-helmet';

const PAGE_TITLE = 'accessControlPage_Title';

export default function AccessControlPage() {
  const { t } = useTranslation();
  return (
    <MainContent title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />

      <div className="ant-layout-content-body">
        <Tabs>
          <Tabs.TabPane tab={t('accessControlPage_Password')} key="password">
            <PasswordConfiguration />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('accessControlPage_Requirement')} key="2fa">
            <TowfactorAuthConfiguration />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </MainContent>
  );
}
